import React from 'react';
import ReactDOM from 'react-dom';

import styled from 'styled-components';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(1, 1, 1, 0.4);
  z-index: 999999;
  display: flex;
  justify-content: center;
  align-items: center;
  .modal {
    box-sizing: border-box;
    max-width: 720px;
    min-width: 300px;

    max-height: 90vh;
    width: 75vw;
    background: white;
    padding: 30px;
    position: relative;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    h3 {
      font-size: 28px;
      font-weight: 300;
      color: #444444;
      margin: 0;
      margin-bottom: 50px;
      margin-right: 40px;
    }
    .modal-close {
      position: absolute;
      top: 30px;
      right: 30px;
      font-size: 25px;
      cursor: pointer;
    }
    .modal-options {
      box-shadow: 0 2px 4px 0 rgba(201, 201, 201, 0.2);
      border: solid 1px rgba(218, 220, 224, 0.5);
      overflow: auto;
      flex: 1;
      div {
        padding: 8px 16px;
        line-height: 1.43;
        font-size: 1.4rem;
        color: #444444;
        transition: 0.5s;
        cursor: pointer;
        &:hover {
          background-color: #f6f6f6;
          color: #eb2227;
        }
      }
    }
  }
`;

function Select({ resolve, reject, label, options }) {
  function onClose(event) {
    if (event.target === event.currentTarget) {
      removeModal();
      reject();
    }
  }
  function onSelect(value) {
    removeModal();
    resolve(value);
  }
  console.log(options);
  return (
    <Wrapper onClick={onClose}>
      <div className='modal'>
        <h3>{label}</h3>
        <div class='modal-close' onClick={onClose}>
          x
        </div>
        <div className='modal-options'>
          {options.map((option) => (
            <div onClick={() => onSelect(option.value)} key={option.id}>
              {option.label}
            </div>
          ))}
        </div>
      </div>
    </Wrapper>
  );
}

// options need to be {id, value, label}[]
export function getSelectValue(label, options) {
  return new Promise((resolve, reject) => {
    addModal(resolve, reject, label, options);
  });
}

function addModal(resolve, reject, label, options) {
  const body = document.getElementsByTagName('body')[0];
  const div = document.createElement('div');
  div.setAttribute('id', 'Confirmation-container');
  body.appendChild(div);
  ReactDOM.render(
    <Select
      resolve={resolve}
      reject={reject}
      label={label}
      options={options}
    />,
    div
  );
}

function removeModal() {
  const div = document.getElementById('Confirmation-container');
  const body = document.getElementsByTagName('body')[0];
  body.removeChild(div);
}
